/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package @scandipwa/paypal
 */

import { setInitialState, setPayPalConfig, setPayPalState } from './PayPalPayment.action';

/**
 * AmazonPayPayment Dispatcher
 * @class PayPalPaymentDispatcher
 * @namespace Paypal/Store/PayPalPayment/Dispatcher */
export class PayPalPaymentDispatcher {
    setPayPalState(dispatch, state) {
        dispatch(setPayPalState(state));
    }

    setInitialPayPalState(dispatch) {
        dispatch(setInitialState());
    }
}

export default new PayPalPaymentDispatcher();
